import {
  Container,
  Grid,
  Stack,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React from "react";
import { colors } from "../../assets";
import { SectionHeader } from "../molecules/sectionHeader";

export const CompanyProfileSection = ({ id, title, subtitle, rowItems }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Container maxWidth="lg" id={id}>
      <Stack
        alignItems="center"
        spacing={!isMobile ? "120px" : "60px"}
        style={{ margin: !isMobile ? "120px 0" : "60px 0" }}
      >
        <SectionHeader title={title} subtitle={subtitle} />

        {/* AUM */}
        <Grid
          container
          columns={3}
          direction="row"
          justifyContent="space-around"
          width="100%"
        >
          {rowItems?.map((item, index) => (
            <Grid item key={index} xs={1}>
              <SectionHeader
                title={item?.title}
                subtitle={item?.subtitle}
                style={{ marginInline: "4px" }}
                titleStyle={{
                  fontSize: !isMobile ? "80px" : "32px",
                  color: colors.primary,
                }}
                subtitleStyle={{ fontSize: !isMobile ? "20px" : "12px" }}
              />
            </Grid>
          ))}
        </Grid>
      </Stack>
    </Container>
  );
};
